/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { RiskExclusion, RiskExclusion$inboundSchema } from "./riskexclusion.js";

export type ListRiskExclusionsResult = {
  /**
   * The list of risk exclusions.
   */
  exclusions: Array<RiskExclusion>;
};

/** @internal */
export const ListRiskExclusionsResult$inboundSchema: z.ZodMiniType<
  ListRiskExclusionsResult,
  unknown
> = z.object({
  exclusions: z.array(RiskExclusion$inboundSchema),
});

export function listRiskExclusionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListRiskExclusionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRiskExclusionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRiskExclusionsResult' from JSON`,
  );
}
